import { TradeAllyListType } from '..';
import { formatNumber } from '../../ContractorCard/util/formatNumber';
import { formatPlural } from '../../ContractorCard/util/formatPlural';

type HeadingType = {
  headingLogo: string;
  results: TradeAllyListType;
  underFourResultsMessage: string;
};

const Heading = ({ headingLogo, results, underFourResultsMessage }: HeadingType) => {
  return (
    <div>
      <img src={headingLogo} alt="" aria-hidden className="w-48 h-48 mx-auto mb-12"></img>
      <h3 className="text-xl text-blue-dark text-center mb-12 capitalize">
        Why {formatNumber(results.length)} {formatPlural(results, 'Result')}?
      </h3>
      <p>{underFourResultsMessage}</p>
    </div>
  );
};

export default Heading;
